import { render, staticRenderFns } from "./KimonoFilter.vue?vue&type=template&id=3e2635d6&scoped=true&"
import script from "./KimonoFilter.vue?vue&type=script&lang=js&"
export * from "./KimonoFilter.vue?vue&type=script&lang=js&"
import style0 from "./KimonoFilter.vue?vue&type=style&index=0&id=3e2635d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2635d6",
  null
  
)

export default component.exports